import { ConnectedPosition } from '@angular/cdk/overlay';

export const SVG_BASE_URL =
  'https://raw.githubusercontent.com/hampusborgos/country-flags/main/svg';

export const positions: ConnectedPosition[] = [
  {
    originX: 'start',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top'
  },
  {
    originX: 'end',
    originY: 'bottom',
    overlayX: 'end',
    overlayY: 'top'
  },
  {
    originX: 'start',
    originY: 'top',
    overlayX: 'start',
    overlayY: 'bottom',
    panelClass: 'select-panel-above'
  },
  {
    originX: 'end',
    originY: 'top',
    overlayX: 'end',
    overlayY: 'bottom',
    panelClass: 'select-panel-above'
  }
];
